export default "__VITE_ASSET__CSlSn5tZ__"